import { useTranslation } from 'react-i18next';

import { PlanSection } from '../PlanSection/PlanSection';

export function MarketsSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection
      title={t('planWizard.sections.markets.title')}
      description={t('planWizard.sections.markets.description')}
    >
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-655 - Markets</p>
    </PlanSection>
  );
}

MarketsSection.displayName = 'MarketsSection';
